import React, { useContext, useEffect, useRef, useState } from 'react'
import { VscMenu } from "react-icons/vsc";
import { Link, redirect } from 'react-router-dom';
import { clearLoginInfo } from '../../configurations/auth/clearLoginInfo';
import { authContext } from '../../configurations/auth/authContext';
import { getLoginInfo } from '../../configurations/auth/getLoginInfo';
import { useTopMenuOpen } from './topMenuContext';
import Dp from '../app/users/Dp';
import { FaChartPie, FaHospital, FaPen, FaPlus, FaStethoscope } from 'react-icons/fa'
import { FiKey, FiLogOut } from "react-icons/fi";
import { HiChevronDown, HiOutlineUserCircle } from "react-icons/hi2";
import { FaRupeeSign } from "react-icons/fa";
import { FaBookMedical } from "react-icons/fa";
import { FaHistory } from "react-icons/fa";
import GlobalLoader from './GlobalLoader';
import { FaBriefcaseMedical } from "react-icons/fa6";

export default function SideBar({ isDoctor = true }) {
    const [isLogin, setIsLogin] = useContext(authContext);
    const [isOpen, setIsOpen] = useState(false)
    const [isTopMenuOpen, changeTopMenu, closeTopMenu] = useTopMenuOpen()
    const userData = getLoginInfo();
    const [isDropdownOpen, setIsDropdownOpen] = useState({
        user: false,
        opdcenter: false,
    })
    const [menuOpen, setMenuOpen] = useState(false);
    const menuref = useRef();
    useEffect(() => {
        const close = (e) => {
            if (menuref.current && !menuref.current.contains(e.target)) {
                setMenuOpen(false)
            }
        };
        document.addEventListener("click", close);
        return () =>
            document.removeEventListener("click", close);
    }, []
    );

    function toggleMenu() {
        setMenuOpen(!menuOpen);
    }

    function closeMenu() {
        setMenuOpen(false);
        setIsOpen(false)
    }

    const isDropdownChange = (name) => {
        switch (name) {
            case "user": { setIsDropdownOpen({ user: !isDropdownOpen.user, opdcenter: false }); break; }
            case "opdcenter": { setIsDropdownOpen({ opdcenter: !isDropdownOpen.opdcenter, user: false }); break; }
        }
    }


    const changeIsOpen = () => {
        setIsOpen(!isOpen)
    }

    const logout = () => {
        clearLoginInfo()
        setIsLogin(false)
        redirect("/login")
    }
    return (
        <>
            <nav class="fixed top-0 z-50 w-full bg-white border-b border-gray-200 shadow-md">
                <div class="px-3 py-2">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center justify-start rtl:justify-end">
                            <button onClick={() => { changeIsOpen(); closeTopMenu(); }} type="button" class="inline-flex rounded-sm shadow-md items-center p-2 text text-white bg-sky-400 hover:bg-sky-300 focus:outline-none ">
                                <span class="sr-only">Open sidebar</span>
                                <VscMenu className='h-6 w-6' />

                            </button>
                            <Link to="/home" class="flex ms-2 md:me-24" onClick={() => { setIsOpen(false); closeTopMenu(); }}>
                                <img src="/assets/images/logo.png" class="h-9 me-2" alt="Doctora" />
                            </Link>
                        </div>
                        <div class="flex items-center">
                            <div className="relative"
                                ref={menuref}
                            >
                                <button onClick={toggleMenu} className="text-sm text-gray-700 cursor-pointer  hover:bg-slate-200 rounded-full p-1">
                                    <div className='flex items-center justify-end gap-2 sm:ms-3'>
                                        <div className='hidden sm:flex'>Dr. {userData.fullName}</div>
                                        <div>
                                            <Dp user={userData} height={"h-9"} width={"w-9"} />
                                        </div>
                                    </div>
                                </button>

                                {menuOpen && (
                                    <div className="absolute right-0 mt-2 w-48 border-t-4 border-t-sky-400 bg-white border-b-4 border-sky-400 hover:shadow-2xl rounded-b-md shadow-lg z-50 text-sm">
                                        <div
                                            className="flex flex-col items-start px-4 py-2 bg-slate-200"
                                        >
                                            <p class="text-sm font-medium text-gray-900 truncate">
                                                Dr. {userData.fullName}
                                            </p>
                                            <p class="text-sm  text-gray-900 truncate ">
                                                {userData.userName}
                                            </p>
                                        </div>
                                        <Link to="/profile"
                                            className="flex items-center px-4 py-2  hover:bg-slate-100 cursor-pointer"
                                            onClick={closeMenu}
                                        >
                                            <HiOutlineUserCircle className="mr-2 text-blue-700" />
                                            Profile
                                        </Link>
                                        <Link to="/change-password"
                                            className="flex items-center px-4 py-2 hover:bg-slate-100 cursor-pointer"
                                            onClick={closeMenu}
                                        >
                                            <FiKey className="mr-2 text-purple-500" />
                                            Change Password
                                        </Link>
                                        <div
                                            className="flex items-center px-4 py-2 hover:bg-slate-100 cursor-pointer"
                                            onClick={() => { closeMenu(); logout(); }}
                                        >
                                            <FiLogOut className="mr-2 text-red-500" />
                                            Logout
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <GlobalLoader />
            </nav>

            <aside class={"fixed top-0 left-0 z-50 w-64 pb-[61px] h-screen mt-[60px] transition-transform " + (isOpen ? "transform-none shadow-2xl" : "-translate-x-full") + " bg-white border-r border-gray-100"}>
                <div class="h-full px-3 pb-4 pt-4 overflow-y-auto bg-white border-t border-t-gray-300">
                    <ul class="space-y-2" >
                        <li onClick={changeIsOpen}>
                            <Link to="home" class="flex items-center p-2 text-gray-900 rounded-lg  hover:bg-gray-100">
                                <FaChartPie className="text-sky-500 text-lg" />
                                <span class="ms-3">Dashboard</span>
                            </Link>
                        </li>
                        <li onClick={changeIsOpen}>
                            <Link to="/startopd" class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group">
                                <FaStethoscope className="text-green-600 text-lg" />
                                <span class="flex-1 ms-3 whitespace-nowrap font-semibold text-green-600 ">Start OPD</span>
                            </Link>
                        </li>
                        <li onClick={changeIsOpen}>
                            <Link to="/lookout" class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group">
                                <FaBriefcaseMedical className="text-lime-500 text-lg" />
                                <span class="flex-1 ms-3 whitespace-nowrap">Look Out OPD</span>
                            </Link>
                        </li>
                        <li onClick={changeIsOpen}>
                            <Link to="/opdcenter/all" class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group">
                                <FaHospital className="text-blue-700 text-lg" />
                                <span class="flex-1 ms-3 whitespace-nowrap">Centers</span>
                            </Link>
                        </li>
                        {/* <li>
                            <button onClick={() => isDropdownChange('opdcenter')} type="button" class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100" aria-controls="dropdown-example" data-collapse-toggle="dropdown-example">
                                <FaHospital className="text-blue-700 text-xl" />
                                <span class="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap">Centers</span>
                                <HiChevronDown className="w-6 h-6 text-current" />
                            </button>
                            <ul id="dropdown-example" class={(isDropdownOpen.opdcenter ? "" : "hidden") + " py-2 space-y-2"}>
                                <li onClick={changeIsOpen}>
                                    <Link to="/opdcenters/add" class="flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100">
                                        <FaPlus className='text-green-600' />
                                        <span class="flex-1 ms-3 whitespace-nowrap">Add Center</span>
                                    </Link>
                                </li>
                                <li onClick={changeIsOpen}>
                                    <Link to="opdcenter/all" class="flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100">
                                        <FaMagnifyingGlass className='text-blue-600' />
                                        <span class="flex-1 ms-3 whitespace-nowrap">View Center</span>
                                    </Link>
                                </li>

                            </ul>
                        </li> */}
                        <li onClick={changeIsOpen}>
                            <Link to="/opdregister" class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group">
                                <FaHistory className="text-red-500 text-lg" />
                                <span class="flex-1 ms-3 whitespace-nowrap">OPD History</span>
                            </Link>
                        </li>
                        {
                            isDoctor &&
                            <li onClick={changeIsOpen}>
                                <Link to="/fastnotes/view" class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group">
                                    <FaPen className="text-purple-600 text-lg" />
                                    <span class="flex-1 ms-3 whitespace-nowrap">Fast Note</span>
                                </Link>
                            </li>
                        }
                        <li>
                            <button onClick={() => isDropdownChange('opdcenter')} type="button" class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100" aria-controls="dropdown-example" data-collapse-toggle="dropdown-example">
                                <FaRupeeSign className="text-teal-600 text-lg" />
                                <span class="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap">Recharge</span>
                                <HiChevronDown className="w-4 h-4 text-current" />
                            </button>
                            <ul id="dropdown-example" class={(isDropdownOpen.opdcenter ? "" : "hidden") + " py-2 space-y-2"}>
                                <li onClick={changeIsOpen}>
                                    <Link to="/recharge" class="flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100">
                                        <FaPlus className='text-green-600' />
                                        <span class="flex-1 ms-3 whitespace-nowrap">New Recharge</span>
                                    </Link>
                                </li>
                                <li onClick={changeIsOpen}>
                                    <Link to="/rechargehistory" class="flex items-center w-full p-2 text-gray-900 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100">
                                        <FaBookMedical className='text-amber-600' />
                                        <span class="flex-1 ms-3 whitespace-nowrap">Recharge History</span>
                                    </Link>
                                </li>

                            </ul>
                        </li>
                    </ul>
                </div>
            </aside>

            {isOpen && <div onClick={() => { changeIsOpen(); closeTopMenu(); }} drawer-backdrop="" class="bg-gray-900/50 fixed inset-0 z-30"></div>}
        </>
    )
}
